import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../configureStore';

export const userSelector = ({ entities }: RootState) => {
  return entities.user;
};

export const getCompanyUsers = createSelector(
  userSelector,
  (user) => {
    return user?.users;
  },
);